








































import { Component, Vue } from 'vue-property-decorator';
import ActionTypes from '@/constants/action-types';
import { OrderReceiptModel } from '@/models/OrderReceiptModel';
import PickupAddress from '@/components/receipt/PickupAddress.vue';
import GoogleMap from '@/components/common/GoogleMap.vue';
import ReceiptCart from '@/components/receipt/ReceiptCart.vue';
import OrderDetails from '@/components/receipt/OrderDetails.vue';
import ReceiptHead from '@/components/receipt/ReceiptHead.vue';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';

@Component({
  components: {
    ReceiptHead,
    OrderDetails,
    ReceiptCart,
    GoogleMap,
    PickupAddress,
  },
})
export default class Receipt extends Vue {
  private isLoading = false;

  async mounted(): Promise<void> {
    if (!this.isAuthenticated) {
      await this.$router.push('/');
      return;
    }

    await this.loadReceipt();

    if (!this.merchant) {
      await this.$store.dispatch(`merchant/${ActionTypes.GetMerchantDetails}`, this.receipt?.merchantId);
    }
  }

  private get isAuthenticated(): boolean {
    return Boolean(this.$store.state.user.auth);
  }

  private get merchant(): MerchantDetailsModel | null {
    return this.$store.state.merchant.merchant;
  }

  private get merchantPhone(): string | undefined {
    return this.merchant?.phone;
  }

  private get receipt(): OrderReceiptModel | null {
    return this.$store.state.order.orderReceipt;
  }

  private get timezone(): string | undefined {
    return this.merchant?.timezone;
  }

  private async loadReceipt(): Promise<void> {
    const { orderId } = this.$route.params;
    this.isLoading = true;
    await this.$store.dispatch(`order/${ActionTypes.GetOrderReceipt}`, orderId);
    this.isLoading = false;
  }
}

